// @flow
import React from 'react';
import styled from 'styled-components';
import {
  Icon,
  IconLookup,
} from 'trustar-2.0/components';

export const Badge = (props: Object) => {
  const Button = styled.button`
    && {
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.33rem;

      cursor: pointer;
      border: 1px solid ${({theme}) => theme.ThemeColors.TEXT.hex};
      border-radius: 3px;
      color: ${({theme}) => theme.ThemeColors.TEXT.hex};
      background-color: ${({theme}) => theme.ThemeColors.SURFACE.hex};
      padding: 4px .833rem 4px .833rem;
      margin-top: 1rem;
      margin-right: 21px;
      vertical-align: middle;
      display: inline;
    }
  `;
  const StyledIcon = styled(Icon)`
    && {
      line-height: 1rem;
      font-size: .8rem;
      margin-right: 5px;
      vertical-align: middle;
    }
  `;
  return (
    <Button {...props}
      size='large'
      onClick={() => {
        props.onClick(props.badgeKey);
      }}
    >
      <StyledIcon icon={IconLookup.CROSS} />
      {props.children}</Button>
  );
};

Badge.defaultProps = {
  badgeKey: '',
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Badge.js